import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export const TagViewCypressAttribute: CypressAttribute = {
  buttons: {},
  inputs: {},
  views: {
    TAG: 'TagViewCypressAttribute:views:TAG'
  }
};
